import { render, staticRenderFns } from "./CardLoading.vue?vue&type=template&id=56222b3a&scoped=true"
import script from "./CardLoading.vue?vue&type=script&lang=js"
export * from "./CardLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56222b3a",
  null
  
)

export default component.exports